import { Component, OnInit } from '@angular/core';
import { FilterDetails, MedicalTest, MedicalTestCarouselItems } from '../../models';
import { Router } from '@angular/router';
import { User } from '../../models/user.model';
import { MedicalTestService, DataService, DocumentService } from '../../services';

@Component({
  selector: 'app-services',
  templateUrl: './services.component.html',
  styleUrls: ['./services.component.scss']
})
export class ServicesComponent implements OnInit {
  user: User;
  filterIcons: FilterDetails[] = [];
  groupedMedicalTests: MedicalTestCarouselItems[];
  categoryNames: string[] = [];
  stateOfFilter: boolean[] = [];
  medicalTests: MedicalTest[];
  category1: MedicalTest[] = [];
  category2: MedicalTest[] = [];
  category3: MedicalTest[] = [];
  category4: MedicalTest[] = [];
  slickCarouselConfig: any;
  slickCarouselConfigCommonTestsCategory: any;

  constructor(
    private router: Router,
    private medicalTestService: MedicalTestService,
    private dataService: DataService,
    private documentService: DocumentService,
  ) {}

  ngOnInit() {
    const commonConfig = {
      ...this.documentService.getslickCarouselConfig(),
      slidesToScroll: 1
    }
    this.slickCarouselConfig = {
       ...commonConfig,
       autoplay: false,
       autoplaySpeed: 3000,
    };
    this.slickCarouselConfigCommonTestsCategory = {
       ...commonConfig,
       autoplay: true,
       autoplaySpeed: 5000,
    };    
    if (this.medicalTestService.getMedicalTests()) {
      this.medicalTestService.getMedicalTests().subscribe(
        medicalTests => {
          this.groupedMedicalTests = this.getGroupedData(medicalTests as MedicalTest[]);
          //TODO: Assign tests to respective categories as a temporary solution 
          this.category1 = this.filterTestsByCategory('Common Medical Tests');
          this.category2 = this.filterTestsByCategory('Basic Health Checkups');
          this.category3 = this.filterTestsByCategory('Routine Blood Tests');
          this.category4 = this.filterTestsByCategory('Infectious Diseases');
        });
    }
  }

  getGroupedData(medicalTests: MedicalTest[]) {
    return medicalTests.reduce(
      (total: MedicalTestCarouselItems[], { category }) => {
        if (!total.some(element => element.category === category)) {
          total.push({ category, groupItems: medicalTests.filter(element => element.category === category) });
        }
        return total;
      }, []);
  }

  filterTestsByCategory(category: string): MedicalTest[] {
    return this.groupedMedicalTests?.find(group => group.category === category)?.groupItems || [];
  }

  goToMedicalTestDetails(medicalTest: MedicalTest) {
    this.dataService.saveLocalDataToView(medicalTest);
    this.router.navigate(['medical-test-details']);
  }
}
